function pushDL(payload) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

function isoNow() {
  return new Date().toISOString();
}

function getVariantLabel(test) {
  if (test.variantLabel) {
    return test.variantLabel;
  }

  if (String(test.variantValue) === '1') {
    return 'A';
  }

  if (String(test.variantValue) === '2') {
    return 'B';
  }

  return String(test.variantValue || '');
}

function getInteractionParams(interaction, element) {
  const params = Object.assign({}, interaction.params || {});
  const dataAttributes = interaction.dataAttributes || {};

  Object.keys(dataAttributes).forEach(paramName => {
    const dataAttributeName = dataAttributes[paramName];
    const sourceElement =
      element.closest(`[data-${dataAttributeName}]`) || element;
    const value = sourceElement.getAttribute(`data-${dataAttributeName}`);

    if (value !== null && value !== '') {
      params[paramName] = value;
    }
  });

  return params;
}

function bindClickInteraction(test, interaction) {
  if (!interaction.selector || !interaction.event) {
    return;
  }

  document.addEventListener('click', event => {
    const target = event.target.closest(interaction.selector);

    if (!target) {
      return;
    }

    const payload = Object.assign(
      {
        event: interaction.event,
        ab_area: test.area,
        ab_test: test.test,
        ab_variant: getVariantLabel(test),
        timestamp: isoNow()
      },
      getInteractionParams(interaction, target)
    );

    pushDL(payload);
  });
}

function bindChangeInteraction(test, interaction) {
  if (!interaction.selector || !interaction.event) {
    return;
  }

  document.addEventListener('change', event => {
    const target = event.target.closest(interaction.selector);

    if (!target) {
      return;
    }

    const payload = Object.assign(
      {
        event: interaction.event,
        ab_area: test.area,
        ab_test: test.test,
        ab_variant: getVariantLabel(test),
        timestamp: isoNow()
      },
      getInteractionParams(interaction, target)
    );

    if (interaction.targetValueParam) {
      if (target.type === 'checkbox') {
        payload[interaction.targetValueParam] = target.checked
          ? target.value
          : false;
      } else if (typeof target.value !== 'undefined') {
        payload[interaction.targetValueParam] = target.value;
      }
    }

    pushDL(payload);
  });
}

function bindInteractions(test) {
  const interactions = Array.isArray(test.interactions) ? test.interactions : [];

  interactions.forEach(interaction => {
    if (!interaction || !interaction.type) {
      return;
    }

    if (interaction.type === 'click') {
      bindClickInteraction(test, interaction);
    }

    if (interaction.type === 'change') {
      bindChangeInteraction(test, interaction);
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const config = window.wlABTesting || {};
  const tests = Array.isArray(config.tests) ? config.tests : [];

  tests.forEach(test => {
    if (!test || !test.area || !test.test || !test.variantValue) {
      return;
    }

    if (test.trackExposure !== false) {
      pushDL({
        event: 'hn_ab_test_exposure',
        ab_area: test.area,
        ab_test: test.test,
        ab_variant: getVariantLabel(test),
        timestamp: isoNow()
      });
    }

    bindInteractions(test);
  });
});
